import { createSlice } from '@reduxjs/toolkit';

export interface CrmResetPasswordState {
    form: {
        isLoading: boolean;
        isSucceed: boolean;
    };
    confirmForm: {
        isLoading: boolean;
        isSucceed: boolean;
    };
}

const initialState: CrmResetPasswordState = {
    form: {
        isLoading: false,
        isSucceed: false,
    },
    confirmForm: {
        isLoading: false,
        isSucceed: false,
    },
};

export const crmResetPasswordSlice = createSlice({
    name: 'crmResetPassword',
    initialState,
    reducers: (create) => ({
        crmResetPasswordFetch: create.reducer((state) => {
            state.form.isLoading = true;
            state.form.isSucceed = false;
        }),
        crmResetPasswordSucceeded: create.reducer((state) => {
            state.form.isLoading = false;
            state.form.isSucceed = true;
        }),
        crmResetPasswordFailed: create.reducer((state) => {
            state.form.isLoading = false;
            state.form.isSucceed = false;
        }),
        clearCrmResetPassword: create.reducer((state) => {
            state.form.isLoading = false;
            state.form.isSucceed = false;
        }),

        crmResetPasswordConfirmFetch: create.reducer((state) => {
            state.confirmForm.isLoading = true;
            state.confirmForm.isSucceed = false;
        }),
        crmResetPasswordConfirmSucceeded: create.reducer((state) => {
            state.confirmForm.isLoading = false;
            state.confirmForm.isSucceed = true;
        }),
        crmResetPasswordConfirmFailed: create.reducer((state) => {
            state.confirmForm.isLoading = false;
            state.confirmForm.isSucceed = false;
        }),
        clearCrmResetPasswordConfirm: create.reducer((state) => {
            state.confirmForm.isLoading = false;
            state.confirmForm.isSucceed = false;
        }),
    }),
    selectors: {
        selectIsCrmResetPasswordFormLoading: (crmResetPassword) => crmResetPassword.form.isLoading,
        selectIsCrmResetPasswordSucceeded: (crmResetPassword) => crmResetPassword.form.isSucceed,

        selectIsCrmResetPasswordConfirmFormLoading: (crmResetPassword) => crmResetPassword.confirmForm.isLoading,
        selectIsCrmResetPasswordConfirmSucceeded: (crmResetPassword) => crmResetPassword.confirmForm.isSucceed,
    },
});

export const {
    crmResetPasswordFetch,
    crmResetPasswordSucceeded,
    crmResetPasswordFailed,
    clearCrmResetPassword,

    crmResetPasswordConfirmFetch,
    crmResetPasswordConfirmSucceeded,
    crmResetPasswordConfirmFailed,
    clearCrmResetPasswordConfirm,
} = crmResetPasswordSlice.actions;
export const {
    selectIsCrmResetPasswordFormLoading,
    selectIsCrmResetPasswordSucceeded,

    selectIsCrmResetPasswordConfirmFormLoading,
    selectIsCrmResetPasswordConfirmSucceeded,
} = crmResetPasswordSlice.selectors;
